export default function() {

    if ( ! String.prototype.getDecimals ) {
        String.prototype.getDecimals = function() {
            var num = this,
                match = ('' + num).match(/(?:.(d+))?(?:[eE]([+-]?d+))?$/);
            if ( ! match ) {
                return 0;
            }
            return Math.max( 0, ( match[1] ? match[1].length : 0 ) - ( match[2] ? +match[2] : 0 ) );
        }
    }


    const qtyControls = document.querySelectorAll('.qty_button')
    if(qtyControls) {
        // qtyControls.forEach((control) => {
        //     document.addEventListener('click', function(e){
        //         if(e.target.classList.contains('qty_button')) {
        //             alterQty(e.target)
        //         }
        //     });
        // });
        // }
        document.addEventListener('click', function(e){
            if(e.target.classList.contains('qty_button')) {
                alterQty(e.target)
            }
        });

        function alterQty(control) {
            var $qty    = control.closest( '.quantity' ).querySelector( '.qty'),
            currentvalue  = parseFloat( $qty.value ),
            max         = parseFloat( $qty.getAttribute( 'max' ) ),
            min         = parseFloat( $qty.getAttribute( 'min' ) ),
            step        = $qty.getAttribute( 'step' );

           // Format valueues
            if ( ! currentvalue || currentvalue === '' || currentvalue === 'NaN' ) currentvalue = 0;
            if ( max === '' || max === 'NaN' ) max = '';
            if ( min === '' || min === 'NaN' ) min = 0;
            if ( step === 'any' || step === '' || step === undefined || parseFloat( step ) === 'NaN' ) step = 1;

                    // Change the valueue
                    if ( control.classList.contains( 'plus' ) ) {
                        if ( max && ( currentvalue >= max ) ) {
                            $qty.value = max;
                        } else {
                            $qty.value = ( currentvalue + parseFloat( step )).toFixed( step.getDecimals() );
                            $($qty).trigger('change')
                        }
                    } else {
                        if ( min && ( currentvalue <= min ) ) {
                            $qty.value = min ;
                        } else if ( currentvalue > 0 ) {
                            $qty.value = ( currentvalue - parseFloat( step )).toFixed( step.getDecimals() );
                            $($qty).trigger('change')
                        }
                    }

            // If on cart, trigger update cart
            if(document.body.classList.contains('woocommerce-cart')) {
                $("[name='update_cart']").trigger("click");
            }
        };
    }
                
}